import React from 'react'
import { parse } from '@wordpress/block-serialization-default-parser'
import Fade from 'react-reveal/Fade'
import Image from '../Image'
import { StaticQuery, graphql } from 'gatsby'
import VideoPlayer from '../VideoPlayer'
import ReactHtmlParser from 'react-html-parser';
import { StFigure, CoreBlock, CoreParagraph, CoreVideoEmbed} from './WordPressRawContent.css'

const WordpressRawContent = ( {raw} ) => {
  const parsedContent = parse(raw)
  return (
    <div className="wpcontent">
      {
        parsedContent.map((block, index) => {
          if(typeof block.blockName === 'object' && block.blockName === null)
            return null

          if (block.blockName === 'core/image') {
            const parsedhtml = ReactHtmlParser(block.innerHTML)

            if(parsedhtml[0].type === 'figure'){
              const figure = parsedhtml[0]
              const figcaption = figure.props.children.filter(element => element.type === 'figcaption' )
              const validclasses = ['grayscale', 'duotone']
              const filteredarr = validclasses.filter(value => -1 !== figure.props.className.indexOf(value))
              const typeclass = filteredarr && filteredarr.length > 0 ? filteredarr[0] : ''

              return (
                <Fade bottom key={index}>
                  <StFigure>
                    <WpImageToLocal wordpressid={block.attrs.id} type={typeclass} />
                    {
                      figcaption.length > 0 && (
                        <figcaption>{figcaption}</figcaption>
                      )
                    }
                  </StFigure>
                </Fade>
              )
            }

            return (
              <Fade bottom key={index}>
                <WpImageToLocal wordpressid={block.attrs.id} />
              </Fade>
            )
          }
          if (block.blockName === 'core-embed/vimeo') {
            return (
              <Fade bottom key={index}>
                <CoreVideoEmbed>
                  <VideoPlayer url={block.attrs.url} key={index} />
                </CoreVideoEmbed>
              </Fade>
            )
          }
          if (block.blockName === 'core/paragraph') {
            return (
              <Fade bottom key={index}>
                <CoreParagraph className="coreParagraph" dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
              </Fade>
            )
          } else {
            // console.log(block)
            return (
              <Fade bottom key={index}>
                <CoreBlock dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
              </Fade>
            )
          }
        })
      }
    </div>
  )
}

const WpImageToLocal = (props) => (
  <StaticQuery
    query={graphql`
      query {
        images: allWordpressWpMedia {
          edges {
            node {
              wordpress_id
              source_url
            }
          }
        }
      }
    `}
    render={(data) => {
      const imagepath = data.images.edges.find(n => {
        return n.node.wordpress_id === props.wordpressid
      })
      if (!imagepath) { return null }
      const filename = imagepath.node.source_url.split('\\').pop().split('/').pop()
      return (
        <Image filename={filename} type={ props.type } />
      )
    }}
  />
)

export default WordpressRawContent